export default __webpack_public_path__ + "static/media/whatcard2.a9437787.svg";